import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllListasPrecios } from '../../../Services/listaPrecioService'

const usePagination = (history, isActive = true) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [isLoad, setIsLoad] = useState(true)
    const [listasPrecios, setListasPrecios] = useState([])

    //Pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const lastSearchRef = useRef('')
    const [disabledButton, setDisabledButton] = useState(true)

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllListasPrecios(isActive, 0, query)
                .then((res) => {
                    setListasPrecios(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                    setDisabledButton(res.data.content.length === 0)

                })

                .catch((err) => console.log('error'))


        } else {
            setIsLoad(false)
        }

    }, [history, isLoad, query, rol, isActive])
    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllListasPrecios(isActive, page + 1)
            .then((res) => {
                setPage(page + 1)
                setListasPrecios(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
                setDisabledButton(res.data.content.length === 0) // 

            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllListasPrecios(isActive, page - 1)
            .then((res) => {
                setPage(page - 1)
                setListasPrecios(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
                setDisabledButton(res.data.content.length === 0)
            })
            .catch((err) => console.log('error'))
    }

    const handleBuscador = (e) => {
        setQuery(e.target.value)

        if (e.key === 'Enter') {
            const trimmedValue = e.target.value.trim()

            // Si el input está vacío y había una búsqueda previa, se resetean todos los datos
            if (trimmedValue === '' && lastSearchRef.current !== '') {
                getAllListasPrecios(isActive, 0, '')
                    .then((res) => {
                        setPage(0)
                        setListasPrecios(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = '' 
                        setDisabledButton(res.data.content.length === 0)


                    })
                    .catch((err) => console.log('error'))
            }
            // Si hay contenido y es diferente a la última búsqueda, hace una nueva búsqueda

            else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {

                 getAllListasPrecios(isActive, 0, trimmedValue)
                     .then((res) => {
                         setPage(0)
                         setListasPrecios(res.data.content)
                         setTotalRegister(res.data.totalElements)
                         setTotalPage(res.data.totalPages)
                         setIsLoad(false)
                         lastSearchRef.current = trimmedValue
                         setDisabledButton(res.data.content.length === 0)
 
                     })
                     .catch((err) => console.log('error'))
             }
        }


    }
    return {
        isLoad,
        listasPrecios,
        page,
        totalRegister,
        totalPage,
        nextPage,
        previousPage,
        handleBuscador,
        setIsLoad,
        disabledButton
    }
}

export default usePagination
